import { withFieldHint } from "@/src/components/HighOrderComponents";
import { SelectField } from "@/src/components/Fields/SelectField";
import { useFormContext } from "react-hook-form";
import { useSourceApiDictionary } from "@/src/hooks/useSourceApiDictionary";

import {
  useFieldDebouncedCallback,
  useUpdateField,
} from "@/src/hooks/useFieldDebouncedCallback";
import { SelectFieldOptionType } from "../lib/type";
import { USE_SELECT_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";

const SelectWithHint = withFieldHint(SelectField);

export function Select(props: any) {
  const { name } = props;
  const hints = props?.hint?.hintsList;
  const form = useFormContext();
  const { control, setValue } = form;
  const debouncedUpdateField = useFieldDebouncedCallback(
    name,
    USE_SELECT_FIELD_UPDATE_DELAY,
  );
  const updateField = useUpdateField();

  const { mode, source, sourceException } = props;
  const { options, isLoading, onInputChange } = useSourceApiDictionary({
    mode,
    source,
    sourceException,
    options: props?.options,
  });

  const handleChange = (e: any, value: SelectFieldOptionType) => {
    if (!e?.currentTarget?.closest('[role="dialog"]')) {
      debouncedUpdateField(value);
    }
    if (value?.additionalValue && value?.additionalValue?.name) {
      setValue(value.additionalValue.name, value.additionalValue.value);
      if (!e?.currentTarget?.closest('[role="dialog"]')) {
        updateField(value.additionalValue.name, value.additionalValue.value);
      }
    }
  };

  return (
    <SelectWithHint
      {...props}
      control={control}
      name={name}
      hints={hints}
      onChange={handleChange}
      loading={isLoading}
      options={options ?? []}
      onInputChange={onInputChange}
    />
  );
}
